import { type ReactNode } from "react";
import { ActionMenu, Icon } from "../../../primitives";

export type ItemActionMenuProps = {
	/** Names the item in the trigger's label: "Actions for {itemName}". */
	itemName: string;
	testId: string;
	children: ReactNode;
};

/** The ⋯ menu on a panel item. Hidden until the nearest `group/item` ancestor is hovered or focused. */
export const ItemActionMenu = ({ itemName, testId, children }: ItemActionMenuProps) => (
	<ActionMenu
		trigger={<Icon type="ellipsis-horizontal" size="mini" />}
		triggerAriaLabel={`Actions for ${itemName}`}
		triggerClassName="size-6 opacity-0 transition-opacity duration-[120ms] group-hover/item:opacity-100 focus-visible:opacity-100 data-[open]:opacity-100 disabled:pointer-events-none"
		testId={testId}
	>
		{children}
	</ActionMenu>
);
